import { Link } from 'react-router-dom'
import React from 'react'
import { jt, t } from 'ttag'

const ClusterRecommendation = ({ recommendations }) => {
  const fixCssClassName = str => {
    return str.replace(new RegExp('\\.', 'g'), '-')
  }
  const truncateDescription = str => {
    const maxLength = 250

    if (str.length < maxLength) {
      return str
    }

    const remaining = str.slice(maxLength).indexOf('.')

    return str.slice(0, maxLength + 1 + remaining)
  }

  return (
    <div className="recommendations col-sm-3">
      <h3 style={{ color: 'black' }}>{t`Top Cluster`}</h3>
      <ul className="recommendation-listing with-cluster-icon">
        {recommendations?.items?.map(r => {
          const countHtml = <b key={`count-${r.id}`}>{r.count}</b>

          return (
            <li key={`recc-${r.id}`}>
              <div className={`inlist-recommendation cluster-${r.taxonomyId}`}>
                <h3>
                  <span
                    className={`cluster-icon cluster-${fixCssClassName(
                      r.id
                    )} landscape`}>
                  </span>
                  {r.name}
                </h3>
                <p>{truncateDescription(r.description)}</p>
                <p>{jt`${countHtml} results in this cluster`}</p>
                <Link to={r.url} className="btn btn-success no-style pull-right">
                  {t`Explore this cluster`}
                </Link>
                <br className="clear" />
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default ClusterRecommendation
